import { OSBizIDOrgIDMap, SMARTPLUG_URL_PARAMS } from './UtilConstants';

export function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
}

export const getIDParamValueFromSmartplugURL = (idParam) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams?.entries());

  const rawIDValue = params?.[idParam];

  const IDValue =
    rawIDValue == null
      ? null
      : !isNaN(Number(rawIDValue))
      ? Number(rawIDValue)
      : rawIDValue;

  return IDValue;
};

export const getOrgIDFromSmartplugURL = () => {
  const bussinessID = getIDParamValueFromSmartplugURL(
    SMARTPLUG_URL_PARAMS.UC_BUSINESS_ID,
  );

  if (!bussinessID) {
    return null;
  }

  const NumBussinessID = Number(bussinessID);

  return OSBizIDOrgIDMap?.[NumBussinessID]
    ? OSBizIDOrgIDMap[NumBussinessID]
    : null;
};

export const getSmartplugsHeaders = () => {
  const pathname = window.location.pathname;
  const isSmartplugUrl = pathname.includes('smartplugs');
  if (!isSmartplugUrl) {
    return {};
  }

  const smartplugHeaders = {
    [SMARTPLUG_URL_PARAMS.FLOW_TYPE]: getIDParamValueFromSmartplugURL(
      SMARTPLUG_URL_PARAMS.FLOW_TYPE,
    ),
    [SMARTPLUG_URL_PARAMS.UC_BUSINESS_ID]: getIDParamValueFromSmartplugURL(
      SMARTPLUG_URL_PARAMS.UC_BUSINESS_ID,
    ),
    [SMARTPLUG_URL_PARAMS.UC_FLOW_TYPE]: getIDParamValueFromSmartplugURL(
      SMARTPLUG_URL_PARAMS.UC_FLOW_TYPE,
    ),
    [SMARTPLUG_URL_PARAMS.UC_TICKET_ID]: getIDParamValueFromSmartplugURL(
      SMARTPLUG_URL_PARAMS.UC_TICKET_ID,
    ),
  };

  return smartplugHeaders;
};

export const reloadToHost = () => {
  window.location.href = window.location.origin;
};
